export default "__VITE_ASSET__DmDyE3Ej__"